import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import Card from '~/src/components/Card';
import Button from '~/src/components/Button';
import EnabledDisabledStatus from '~/src/components/EnabledDisabledStatus';
import { Heading, Text } from '~/src/components/Typography';
import { ExternalLink } from 'react-feather';

import styles from './styles';
import { useLogout } from '~/src/entities/user';

const SettingsSecurity = ({
  email,
  twoFactorEnabled,
  identityAuthenticated,
  openLinkToIdentitySecurity,
  onToggleTwoStepVerification,
  onChangePassword,
}) => {
  const { mutate: onLogout } = useLogout();

  return (
    <Card>
      <Heading>Security</Heading>
      <div className="mt-6 mb-4">
        <Text htmlElement="p" strong>
          Email
        </Text>
        <Text htmlElement="p">{email}</Text>
      </div>
      <div className={css(styles.settingsFlexRow)}>
        {identityAuthenticated && (
          <Button
            cssStyle={styles.settingsSecurityButton}
            onClick={() => openLinkToIdentitySecurity({ edit: 'password' })}
            Icon={ExternalLink}
          >
            Change password
          </Button>
        )}
        {!identityAuthenticated && (
          <Button
            cssStyle={styles.settingsSecurityButton}
            onClick={onChangePassword}
          >
            Change password
          </Button>
        )}
        <Button cssStyle={styles.settingsSecurityButton} onClick={onLogout}>
          Log out of all your devices and browsers
        </Button>
      </div>
      <div className="mt-6 mb-4">
        <Heading htmlElement="h3" variant="subheading">
          Two-step verification
        </Heading>
      </div>
      <div className={css(styles.settingsRow)}>
        {!identityAuthenticated && (
          <>
            <div className={css(styles.settingsSecurityTwoFactor)}>
              <EnabledDisabledStatus enabled={twoFactorEnabled} />
            </div>
            {!twoFactorEnabled && (
              <Button onClick={onToggleTwoStepVerification}>Enable</Button>
            )}
            {twoFactorEnabled && (
              <Button onClick={onToggleTwoStepVerification}>Disable</Button>
            )}
          </>
        )}
        {identityAuthenticated && (
          <Button
            onClick={() => openLinkToIdentitySecurity()}
            Icon={ExternalLink}
          >
            Manage
          </Button>
        )}
      </div>
    </Card>
  );
};

SettingsSecurity.propTypes = {
  email: PropTypes.string,
  twoFactorEnabled: PropTypes.bool,
  identityAuthenticated: PropTypes.bool,
  openLinkToIdentitySecurity: PropTypes.func,
  onToggleTwoStepVerification: PropTypes.func,
  onChangePassword: PropTypes.func,
};

SettingsSecurity.defaultProps = {
  email: '',
  twoFactorEnabled: false,
  identityAuthenticated: false,
  openLinkToIdentitySecurity: () => {},
  onToggleTwoStepVerification: () => {},
  onChangePassword: () => {},
};

export default SettingsSecurity;
